@import '@styles/fonts.scss';

.signupGate {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 32px 24px;
  text-align: center;
  border: 1px solid var(--yolk-med);
  border-radius: var(--radius-xl);
  background: var(--surface);
}

.bare {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 16px;
  width: 100%;
  text-align: center;
}

.title {
  @include font-body;
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
  color: var(--text);
}

.message {
  @include font-body;
  font-size: 0.95rem;
  margin: 0;
  color: var(--text-muted);
  max-width: 360px;
  line-height: 1.5;
}

.tos {
  @include font-body;
  font-size: 0.75rem;
  margin: -6px 0 0;
  color: var(--text-dim);

  a {
    color: var(--text-dim);
    text-decoration: underline;

    &:hover {
      color: var(--text-muted);
    }
  }
}
